import { useResponsiveValue } from '../../hooks'
import type { RadioCheckSize } from '../../widgets'
import { Check } from '../../widgets'

type ChooseSubSelectCheckProps = {
	readonly className?: string
	readonly selected: boolean
}

export const ChooseSubSelectCheck = ({ className, selected }: ChooseSubSelectCheckProps) => {
	const getResponsiveValue = useResponsiveValue()

	const checkSize = getResponsiveValue<RadioCheckSize>('xs', {
		sm: 'sm',
		md: 'md',
	})

	return <Check className={className} checked={selected} readOnly size={checkSize} />
}
